<script>
import truncate from 'vue-truncate-collapsed';

export default {

  components:{truncate},

  name: "TruncatedText",
  props: {
    text: {
      type: String,
      required: true,
    },
    showMoreLabel: {
      type: String,
      default: "Show more",
    },
    showLessLabel: {
      type: String,
      default: "Show less",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

    methods: {
        onClick(){
          if(this.disabled){
            return
          }
            this.$emit("onClick");
        }
    }

};
</script>


<template>
  <div class="d-flex">
    <img v-if="!this.disabled"
      alt="notes"
      height="15"
      src="@/assets/icons/notes-s.svg"
      class="pr-2"
      @click="onClick()"
    />
    
    <truncate
      class="truncate-inline text-dark"
      collapsed-text-class="collapsed-text"
      action-class="customClass"
      :length="50"
      :less="showLessLabel"
      :text="text"
      :clamp="showMoreLabel"
      @click.native="onClick()"
    />
  </div>
</template>


<style>

.collapsed-text{
    font-size: 11px;
}

.customClass {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: black;
  text-decoration: none;
  cursor: pointer;
  font-size: 10px;
}

</style>